import { render, staticRenderFns } from "./currentSymbol.vue?vue&type=template&id=a441857a&scoped=true&"
import script from "./currentSymbol.vue?vue&type=script&lang=js&"
export * from "./currentSymbol.vue?vue&type=script&lang=js&"
import style0 from "./currentSymbol.vue?vue&type=style&index=0&id=a441857a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a441857a",
  null
  
)

export default component.exports